import { Component, HostListener, OnInit } from '@angular/core';
import { AuthService, CallService, PiopiyService } from './core/services';
import { KEYS } from './core/constants';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  title = 'SATSANG_COMMUNICATION_UI';
  public isSliderOpen: boolean = false;
  // currentUrl: any;  
  constructor(private callService: CallService,
    private authService: AuthService,
    private router: Router
  ) {
  }

  ngOnInit() {
    const isGuestRoute = window.location.pathname.startsWith('/guestUser/');
    const isReady = this.authService.initAuth();

    if (!isReady && !isGuestRoute) {
      this.router.navigate(['/login']);
    }

  }

  closeSlider() {
    this.isSliderOpen = false;
  }

}
